import { Typography } from 'antd';
import {
  DISCLAIMER_V1,
  DISCLAIMER_PREVIEW,
  DISCLAIMER_CURRENT_VERSION,
} from '../../../../../../../constants/accounting';

/**
 * Pre-active customers get the preview notice instead of the versioned v1.0
 * text. v1.0 states the figures are "based on your TACH account activity" —
 * true for a real report, false under demo data — and it carries a version of
 * record that a fabricated statement shouldn't claim.
 */
export function AccountingDisclaimer({
  isPreActive = false,
}: {
  isPreActive?: boolean;
}) {
  return (
    <div
      className="accounting-disclaimer px-4 sm:px-0"
      style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #eee' }}
    >
      <Typography.Paragraph type="secondary" style={{ fontSize: 12 }}>
        {isPreActive ? DISCLAIMER_PREVIEW : DISCLAIMER_V1}
      </Typography.Paragraph>
      {!isPreActive && (
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
          Disclaimer {DISCLAIMER_CURRENT_VERSION}
        </Typography.Text>
      )}
    </div>
  );
}
